import { API2_HOST } from '@/utils/constants';

import fetchData from './http';
import { IBaseResponse } from './types/common';

const host = API2_HOST;

export const uploadImg = (params: any) => {
  const url = `${host}/notification-site/v1/private/feedback/upload_img`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<any>>(url, {
        body: JSON.stringify(params),
      })
      .then((res) => {
        resolve(res.result as any);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

export const submitFeedBack = (params: any) => {
  const url = `${host}/notification-site/v1/private/feedback/submit`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<any>>(url, {
        body: JSON.stringify(params),
      })
      .then((res) => {
        resolve(res.result as any);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

export const getFeedbackAllowed = () => {
  const url = `${host}/notification-site/v1/private/feedback/allowed`;
  return new Promise<any>((resolve, reject) => {
    fetchData
      .post<IBaseResponse<any>>(url)
      .then((res) => {
        resolve(res.result as any);
      })
      .catch((error: any) => {
        reject(error.response ? error.response.data : error);
      });
  });
};

// const feedbackApi = {
//   getFeedbackList: (params: any) =>
//     fetchData.get(path.userFeedback, { body: JSON.stringify(params) }),
//   submitFeedBack: (params: any) =>
//     fetch.post(path.feedback, {
//       body: JSON.stringify(params),
//       hideError: true,
//       headers: setHeaders(),
//     }),
//   uploadImg: (file) =>
//     fetch.post(path.upload, {
//       body: file,
//       flag: 'formData',
//       headers: setHeaders(),
//     }),
//   feedbackAllowed: (params) =>
//     fetch.post(path.feedbackAllowed, {
//       body: JSON.stringify(params),
//       headers: setHeaders(),
//     }),
// };
// export default feedbackApi;
